// import { FC } from 'react';

// import ButtonStyled, { PropsButtons } from './styles';

// const ButtonSubmit: FC<PropsButtons> = ({ children, ...props }) => {
//   return <ButtonStyled {...props}>{children}</ButtonStyled>;
// };

// export default ButtonSubmit;
import { FC } from 'react';
import ButtonStyled from './styles';

interface PropsButtons {
  disabled?: boolean;
  loading?: boolean;
}

const ButtonSubmit: FC<PropsButtons> = ({ children, ...props }) => {
  return (
    <ButtonStyled htmlType="submit" type="primary" {...props}>
      {children}
    </ButtonStyled>
  );
};

export default ButtonSubmit;
